export function isSmallSection(contentType: string): boolean {
  return ['textBlock', 'video', 'imageSingle', 'imageSetOfThree', 'textAndMedia', 'infoBlock'].includes(
    getContentTypeId(contentType),
  );
}

export function getContentTypeId(contentType: string): string {
  return contentType.charAt(0).toLowerCase() + contentType.slice(1);
}

export function getSmallSectionClass(): string {
  return 'text-gray-800 content-page-body md:w-full md:my-0 md:mx-auto md:px-0 md:last-of-type:pb-20';
}

export function getDefaultSectionClass(): string {
  return 'px-4 py-6 mx-auto my-0 md:py-5 md:px-10 lg:px-20';
}
